/**
 * QoCPeriodComparison.jsx
 * Period Comparison is now integrated into the Executive Dashboard as Section 10.
 * This file redirects the /qoc/period-comparison route there.
 */
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Spin } from 'antd';

export default function QoCPeriodComparison() {
    const history = useHistory();
    useEffect(() => {
        history.replace('/qoc/executive-dashboard');
        // After navigation, scroll to the comparison section
        setTimeout(() => {
            const el = document.getElementById('sec-comparison');
            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 600);
    }, []); // eslint-disable-line
    return (
        <div style={{ display:'flex', justifyContent:'center', alignItems:'center', height:'60vh' }}>
            <Spin tip="Redirecting to Executive Dashboard…" size="large"/>
        </div>
    );
}